import swal from 'sweetalert';


// speedbump check - all external links should see the speedbump except those specifically removed
$('a').on('click', function(e) {
    var alertText = "The privacy policy of the site to which you are going may differ from our privacy policy. Click OK to continue or Cancel to remain on our site.";
    var currentHost = window.location.host;
    var linkHost = this.hostname;
    // alert(currentHost + " = " + linkHost);

    if (linkHost.replace(/^www\./, '') === "botwealthmgmt.com") {
        alertText = "The privacy policy of the site to which you are going may differ from our privacy policy. Click OK to continue or Cancel to remain on our site.<br><strong>Investments are not insured by the FDIC; are not deposits; and may lose value.</strong>";
    }

    if(linkHost.length == 0) return;

    // if the link is external, show the speedbump
    if (linkHost !== currentHost) {

        // manual speedbump bypass
        if ($(this).hasClass("nospeedbump")) {
            e.preventDefault();
            // window.open($(this).attr('href'), '_blank');
            openWindow($(this).attr('href'));
        } else {
            e.preventDefault();
            allowedExternal(linkHost, $(this).attr('href'), alertText);
        }
    } else if ($(this).hasClass("external")) {
        e.preventDefault();
        showAlert(alertText, $(this).attr('href'));
        // var answer = confirm(alertText);

        // if (answer) {
        //     // window.open($(this).attr('href'), '_blank');
        //     openWindow($(this).attr('href'));
        // }
    }

});

function openWindow(url) {
    if ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        window.location.href = url;
    } else {
        var a = document.createElement('a');
        a.href = url;
        a.setAttribute('target', '_blank');
        a.click();
    }
}

function showAlert(text, url) {
    swal({
        title: 'You are now leaving Bank of Tennessee\'s website.',
        content: {
            element: 'div',
            attributes: {
                innerHTML: text,
            },
        },
        icon: 'warning',
        buttons: {
            cancel: {
                text: 'Cancel',
                value: null,
                visible: true,
            },
            confirm: {
                text: 'OK',
                value: true,
                visible: true,
            },
        }
    }).then((isConfirm) => {
        if (isConfirm) {
            openWindow(url);
        }
    });
}

// Check if host is a site-wide allowed domain and if so allow redirect.
// If host is not a site-side allowed domain than display confirmation popup.
function allowedExternal(host, href, alertText) {
    $.post('/wp-admin/admin-ajax.php', {
        action: "externalCheck",
        host: host,
        href: href,
    }).done(function(r) {
        // console.log(r)
        if (r.success) {
            // window.open(r.data);
            openWindow(r.data);
        } else {
            showAlert(alertText, r.data);
            // var answer = confirm(alertText);

            // if (answer) {
            //     // window.open(r.data);
            //     openWindow(r.data);
            // }
        }
    });
}